/** Step 1 — Welcome / overview. */

import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import sx from '../setupStyles';

export default function Welcome({ goNext }) {
  const exit = () => {
    // Closes the desktop window (main keeps the existing close-to-tray behaviour).
    if (typeof window !== 'undefined') window.close();
  };

  return (
    <>
      <Box sx={sx.body}>
        <Box sx={sx.centerCol}>
          <Typography variant="h5" fontWeight={600}>
            Welcome to Younote Desktop
          </Typography>
          <Typography color="text.secondary">
            Before you begin, we&apos;ll complete a one-time setup. This configures your local
            database, downloads the data you need, and prepares the application to work offline.
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Estimated time: 2–5 minutes. An internet connection is required for this first-time
            setup.
          </Typography>
        </Box>
      </Box>
      <Box sx={sx.footer}>
        <Button color="inherit" onClick={exit}>
          Exit
        </Button>
        <Button variant="contained" onClick={goNext}>
          Continue
        </Button>
      </Box>
    </>
  );
}
